module.exports = __webpack_public_path__ + "assets/img/ic-arrow-right-b.57a3d83f.svg";